const menuItems = document.querySelectorAll('.sub-menu');

if (menuItems.length) {
  menuItems.forEach(menuItem => {
    const mainItems = menuItem.querySelectorAll('.sub-menu__main li a');
    const showItems = menuItem.querySelectorAll('.sub-menu__menu');

    mainItems.forEach((mainItem, index) => {
      mainItem.addEventListener('mouseenter', () => {
        mainItems.forEach(item => item.classList.remove('is-active'));

        mainItem.classList.add('is-active');

        showItems.forEach(item => item.classList.remove('is-active'));

        if (showItems[index]) {
          showItems[index].classList.add('is-active');
        }
      });
    });
  })
}
